"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StatCard = StatCard;
var _Text = _interopRequireDefault(require("react-native-web/dist/exports/Text"));
var _View = _interopRequireDefault(require("react-native-web/dist/exports/View"));
var _Surface = require("./Surface");
var _UiThemeProvider = require("../theme/UiThemeProvider");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Compact metric card used in stat grids (session summary, comparison
 * drawer, landing metrics). One metric per card; grids compose them.
 *
 * Surface treatment follows the per-mode elevation strategy: dark mode
 * uses the flat `section` tint (overlay separates it from the page), light
 * mode uses a white card with hairline border + soft shadow — the section
 * tint has no edge against a light page and reads washed out.
 */
function StatCard({
  label,
  value,
  helper,
  color,
  icon,
  style,
  ...rest
}) {
  const theme = (0, _UiThemeProvider.useUiTheme)();
  const isLight = theme.mode === 'light';
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Surface.Surface, {
    ...rest,
    variant: isLight ? 'card' : 'section',
    bordered: isLight,
    elevation: isLight ? 1 : 0,
    radius: "small",
    style: [{
      flexDirection: 'row',
      alignItems: 'center',
      gap: theme.spacing.sm,
      paddingVertical: theme.spacing.sm,
      paddingHorizontal: theme.spacing.sm + 2
    }, style],
    children: [icon ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_View.default, {
      style: {
        flexShrink: 0
      },
      children: icon
    }) : null, /*#__PURE__*/(0, _jsxRuntime.jsxs)(_View.default, {
      style: {
        flexShrink: 1
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
        style: {
          fontSize: theme.fontSizes.small,
          color: theme.palette.textSecondary
        },
        children: label
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
        style: {
          fontSize: theme.fontSizes.subtitle,
          fontWeight: '700',
          color: color ?? theme.palette.text,
          fontVariant: ['tabular-nums']
        },
        children: value
      }), helper ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
        style: {
          fontSize: theme.fontSizes.small,
          color: theme.palette.textTertiary
        },
        children: helper
      }) : null]
    })]
  });
}